import type { RiskRecognitionHighlight } from '@cobliteam/api-lib/src/dashboard/riskRecognitions/Types';
import RiskFootage from './RiskFootage';

// import RiskSeverityBadge from './RiskSeverityBadge';

interface RiskEvidenceProps {
  highlight: RiskRecognitionHighlight;
  /** Surface que renderiza (analytics). */
  surface: 'bell' | 'page' | 'toast';
  size?: 'sm' | 'md';
  className?: string;
  /** Abre o detalhe (drawer) — usado pelo clique do badge; o footage tem modal próprio. */
  onOpen?: (highlight: RiskRecognitionHighlight) => void;
}

/**
 * Evidência visual do risco no slot esquerdo do card/linha:
 * - com `media_ids` → footage (thumbnail de vídeo + modal, via RiskFootage) — evento de câmera (fadiga);
 * - senão → badge de criticidade (excesso de velocidade / jornada não trazem vídeo nem coordenada, só
 *   `criticality_score`; a velocidade em si fica no texto). Clique abre o drawer.
 */
const RiskEvidence = ({ highlight, surface, size, className, onOpen }: RiskEvidenceProps) => {
  if ((highlight.metadata?.media_ids?.length ?? 0) > 0) {
    return <RiskFootage highlight={highlight} surface={surface} size={size} className={className} />;
  }

  return null;

  // return <RiskSeverityBadge highlight={highlight} size={size} className={className} onClick={onOpen ? () => onOpen(highlight) : undefined} />;
};

export default RiskEvidence;
